module.exports = __webpack_public_path__ + "static/media/Woman_Tablet_Hero_HEXHYP.61aa5c65.jpg";